import { useEffect, useState } from "react";
import { TPoint } from '../interface';

export function useMouseTrace() {
    const defaultList: TPoint[] = [];
    const list: TPoint[] = [];
    let currentPoint = { X: -10, Y: -10 };
    let curRaf = 0;
    const [pointList, setPointList] = useState(defaultList);
    useEffect(() => {
        const onMouseMove = (e: MouseEvent) => {
            currentPoint = { X: e.clientX, Y: e.clientY };
        };
        window.addEventListener("mousemove", onMouseMove);
        const loop = () => {
            list.unshift(currentPoint);
            setPointList(list.slice(0, 15))
            curRaf = window.requestAnimationFrame(loop);
        }
        loop();
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.cancelAnimationFrame(curRaf);
        };
    }, []);
    return pointList;
}